import { BorderlessTableOutlined, GlobalOutlined, ProfileOutlined, SearchOutlined, UnorderedListOutlined } from "@ant-design/icons";
import styled from "styled-components";
import { ISurvey } from "../../../interfaces/ISurvey";
import { COLORS } from "../../constants/colors";
import { VisualizacionFormulario } from "../../enums/AllEnums";


interface IProp {
    active: boolean;
    props: any;
    method?: () => void;
    borderColor: string;
    textColor: string;
    backgroundcolorheader?: string;
    backgroundcolorbody?: string;
    placeholdercolor?: string;
    opacity?: number;
    item: ISurvey;

}
const CardBox = styled.div<any>`
    color: ${(props) => props.textColor} !important;
    opacity: ${(props) => !!props.opacity ? props.opacity : 1};
    border: 1px ${(props) => props.borderColor} solid transparent;
    overflow: hidden;
    border-radius: 16px;
    width: 32%;
    margin: 2% 0% 2% 0%;
    height: 7.875rem;
    box-shadow: 0px 1px 3px ${COLORS.black_shadow_1} ;
    
    .icon {
        font-size: 1.5em;  
        padding: 10px;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        
       
        color: ${(props) => props.textColor};
    }
    .boxHeader{
        display: flex;
        justify-content: space-between;
        flex-direction: row;
        align-items: center;
        background-color: ${(props) => props.backgroundcolorheader};
        height: 50.969px;
        max-height: 50.969px;
        
        
    }
    .headerTitle {
        color:${(props) => props.textColor};
        border-left: ${(props) => props.textColor} solid 1px;
        width: 98%;
        height: 100%;
        
    }
    .headerTitle h2 {
       
        color: ${(props) => props.textColor};
        padding: 2% 2%;
        text-align: center;
        font-weight: bold;
        font-size: calc(14px + (26 - 14) * ((91vw - 300px) / (3100 - 300)));
        line-height: calc(1.3em + (1.5 - 1.2) * ((91vw - 300px)/(3100 - 300)));
       
        
    }

    .boxBody{
        display: list-item;
        align-items: center;
        background-color:${(props) => props.backgroundcolorbody};
        height: 4.688rem;
    }
    .boxBody h2{
        color: ${COLORS.black_text_color1};
        text-align: center;
        margin: 0% 0% 0% 4.2%;
        
    }
    .boxBody h1{
        color: ${(props) => props.textColor};
        text-align: center;
        font-size: x-large;
        font-weight: bold;
        margin: 0% 0% 0% 4.2%;
    }
    ${props => props.active && (`
        cursor: pointer;
        
        :active {
            opacity: 0.7;
        }

        :hover {
            box-shadow: 1px 1.5px 4px 1px ${COLORS.black_text_color3};
            //transform: scale(1.01);
        }

    `)}
`;




const SurveyItem: React.FC<IProp> = ({ active, backgroundcolorheader, backgroundcolorbody, method, item, borderColor, textColor, opacity }) => {

    const ICON_TYPE: any = {
        Listado: <i className="fa-solid fa-list-ul"></i>,
        Mapa: <i className="fa-regular fa-map"></i>,
        ListadoDetalle: <i className="fa-regular fa-address-book"></i>,
        Tabla: <i className="fa-solid fa-question"></i>
    }

    return (
        <CardBox

            borderColor={borderColor}
            textColor={active === true ? textColor : COLORS.white_color1}

            opacity={opacity}
            active={active}
            backgroundcolorheader={active === true ? backgroundcolorheader : COLORS.black_text_color1}
            backgroundcolorbody={active === true ? backgroundcolorbody : COLORS.black_text_color4}
            onClick={!!active ? method : null}>

            {

            }
            <div className="boxHeader" >
                <div className="icon">{ICON_TYPE[item.visualizacionTipoNombre]}</div>
                <div className="headerTitle"><h2>{item.nombre}</h2></div>
            </div>
            <nav className="boxBody" >
                <h2>Preguntas</h2>
                <h1>{item.pregunta.length}</h1>
            </nav>
        </CardBox>
    )
}

export default SurveyItem;